var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"approveCooperation"},[_vm._v(" approveCooperation ")])
}
var staticRenderFns = []

export { render, staticRenderFns }